import { useEffect, useState } from "react";
import { LoadingSpinner } from "./LoadingSpinner";

// Shown only on the *first* load while the API hasn't responded yet.
// Render free Web Services spin down after 15 min idle, so the first
// request after hibernation can take ~30–50 s. Without this overlay the
// page just looks broken to a first-time visitor.
export function ColdStartOverlay({ visible }: { visible: boolean }) {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    if (!visible) return;
    const t = setInterval(() => setSeconds((s) => s + 1), 1000);
    return () => clearInterval(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(15, 23, 42, 0.55)",
        backdropFilter: "blur(2px)",
        color: "#f8fafc",
        fontFamily: "'Inter', system-ui, sans-serif",
      }}
    >
      <div
        style={{
          background: "#1e293b",
          padding: "32px 40px",
          borderRadius: 12,
          boxShadow: "0 25px 50px -12px rgba(0,0,0,0.5)",
          maxWidth: 420,
          textAlign: "center",
        }}
      >
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <LoadingSpinner size={48} />
        </div>
        <div style={{ fontSize: 18, fontWeight: 600, marginBottom: 8 }}>
          Waking up the server…
        </div>
        <div style={{ fontSize: 14, lineHeight: 1.5, color: "#cbd5e1" }}>
          The FireFair API is hosted on Render's free tier and hibernates
          after 15 minutes of inactivity. First request can take up to
          ~90 seconds.
        </div>
        <div
          style={{
            marginTop: 16,
            fontSize: 12,
            color: "#94a3b8",
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {seconds}s elapsed
        </div>
      </div>
    </div>
  );
}
